module.exports = __webpack_public_path__ + "img/store-and-retrieve-orders.f25f840d.svg";